import { render, staticRenderFns } from "./DisplayDetailUserPanel.vue?vue&type=template&id=f0fd1688&scoped=true"
import script from "./DisplayDetailUserPanel.vue?vue&type=script&lang=js"
export * from "./DisplayDetailUserPanel.vue?vue&type=script&lang=js"
import style0 from "./DisplayDetailUserPanel.vue?vue&type=style&index=0&id=f0fd1688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0fd1688",
  null
  
)

export default component.exports